const phone = process.env.REACT_APP_WHATSAPP_NUMBER;
const text = process.env.REACT_APP_WHATSAPP_TEXT;
const email = process.env.REACT_APP_EMAIL;
const phoneBotarga = process.env.REACT_APP_WHATSAPPBOTARGAS_NUMBER;
const textBotarga = process.env.REACT_APP_WHATSAPPBOTARGAS_TEXT;

//console.log("PHONE:", phone);

export const CONTACT = {
  WHATSAPP_URL : `https://wa.me/${phone}?text=${text}`,
  WHATSAPPBOTARGA_URL : `https://wa.me/${phoneBotarga}?text=${textBotarga}`,
  EMAIL: email,
  EMAIL_URL: `mailto:${email}`,
};